const PERSIAN_DIGITS = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];

const faNumberFormatter =
    typeof Intl !== "undefined" && Intl.NumberFormat
        ? new Intl.NumberFormat("en-US")
        : null;

export default {
    persianDigit: (value) => {
        if (value === null || value === undefined) return "";
        return String(value).replace(/[0-9]/g, (d) => PERSIAN_DIGITS[+d]);
    },
    commaDigit: (value) => {
        if (value === null || value === undefined || value === "") return "";
        const num = Number(String(value).replace(/,/g, ""));
        if (!Number.isNaN(num) && faNumberFormatter) {
            return faNumberFormatter.format(num);
        }
        // fallback
        return String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
};
